import { trackEvent, trackPaymentFailed, trackPaymentDismissed } from "../../Utils/EventTracker";
import { HandlePaymentSuccess } from "./HandlePaymentSuccess";

export const HandlePayment = (subscriptionId, state, dispatch, setLoading, navigate, data) => {
    if (!subscriptionId) {
        console.error("Subscription ID not available yet");
        return;
    }

    const options = {
        key: process.env.REACT_APP_RZP_KEY,
        subscription_id: subscriptionId,
        name: "BillNama",
        description: state?.USERID,
        image: 'https://backbone.billnama.com/malik-backend/uploads/logo.png',
        callback_url: "https://app.billnama.com/success",
        prefill: {
            name: data?.name,
            email: data?.email,
            contact: null,
        },
        handler: function (response) {
            trackEvent("API_FAILED", { 'name': "razorpay_payment_success", "message": response })
            console.log("Payment successful!", response);
            HandlePaymentSuccess(response, state, dispatch, navigate);
        },
        modal: {
            ondismiss: function () {
                console.log("Payment popup closed by user");
                trackPaymentDismissed(subscriptionId, state?.USERID);
                setLoading(false);
            },
        },
        theme: {
            color: "#4759d6",
        },
    };

    const rzp1 = new window.Razorpay(options);

    rzp1.on("payment.failed", function (response) {
        trackPaymentFailed(subscriptionId, response?.error?.description, state?.USERID);
        console.error("Payment failed!", response);
        setLoading(false);
    });


    rzp1.open();
};